<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import QuickReplies from './QuickReplies.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const cards = computed(() => contentAttributes.value?.items ?? []);
const quickReplies = computed(
  () => contentAttributes.value?.quickReplies ?? []
);

const actionIcon = action =>
  action.type === 'link'
    ? 'i-lucide-external-link'
    : 'i-lucide-mouse-pointer-click';

const cardMediaUrl = card => card.media_url || card.mediaUrl;
</script>

<template>
  <BaseBubble class="px-3 py-3" data-bubble-name="cards">
    <div class="flex gap-2 overflow-x-auto pb-1">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="flex flex-col shrink-0 w-52 rounded-lg bg-n-alpha-1 overflow-hidden"
      >
        <img
          v-if="cardMediaUrl(card)"
          :src="cardMediaUrl(card)"
          class="w-full h-28 object-cover"
          alt=""
        />
        <div class="flex flex-col gap-1 p-2.5">
          <p class="text-sm font-medium text-n-slate-12 line-clamp-2">
            {{ card.title }}
          </p>
          <p
            v-if="card.description"
            class="text-xs text-n-slate-11 line-clamp-2"
          >
            {{ card.description }}
          </p>
          <div v-if="card.actions?.length" class="flex flex-wrap gap-1.5 mt-1">
            <span
              v-for="(action, actionIndex) in card.actions"
              :key="actionIndex"
              class="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs bg-n-solid-2 text-n-slate-11 border border-n-weak"
            >
              <span :class="actionIcon(action)" class="size-3" />
              {{ action.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <QuickReplies :quick-replies="quickReplies" />
  </BaseBubble>
</template>
